export default "__VITE_ASSET__DK2J4KTL__"